export default __webpack_public_path__ + "static/media/simboloCores.5ebca977.svg";